export const listPaymentEvents = `
   query listPaymentEvents($filter: PaymentEventsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listPaymentEvents(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                invoiceId
                customerId
                status
                amount
                currency
                paymentIntentId
                chargeId
                paymentMethodLast4
                failureCode
                failureMessage
                occurredAt
                createdByUsername
                created
                updated
           }
           nextToken
       }
   }
`;

export const getPaymentEvent = `
   query getPaymentEvent($id: ID!) {
       getPaymentEvent(id: $id) {
            id
            invoiceId
            customerId
            status
            amount
            currency
            paymentIntentId
            chargeId
            paymentMethodLast4
            failureCode
            failureMessage
            occurredAt
            createdByUsername
            created
            updated
       }
}`;
